(function(angular){
    'use strict';

    var inject = ['$scope', '$stateParams', '$state', '$q', 'dmsProjectUiService',
    'folderManager', 'dmsFolderUiService', 'dmsFolderService', 'dmsGridSelection', '$timeout', 'dmsCacheFactory', 'FlexGridSetUpService'];
    var controller = function($scope:ng.IScope | any, $stateParams:any, $state:any, $q:ng.IQService, dmsProjectUiService:any, folderManager:any, dmsFolderUiService:any, dmsFolderService:any, dmsGridSelection:any, $timeout:any, dmsCacheFactory:any, FlexGridSetUpService:any) {

        const _gridReady = $q.defer();
        const _gridIdReady = $q.defer();
        $q.all([_gridReady.promise, _gridIdReady.promise]).then((results) => {
            const grid = results[0];
            const gridId = results[1];
            FlexGridSetUpService.restoreColumnVisibility(gridId, grid);
        });
        $scope.gridInitialized = (grid:any) => {
            _gridReady.resolve(grid);
            $scope.gridColumns = grid.columns;
        };

        $scope.selectedGridItems = null;
        // Initialize so the dms-item watcher will find it reliably
        $scope.flatContainer = '';

        dmsGridSelection.get('documents').onChange(function(selected:any) {
            $scope.selectedGridItems = selected;
        });

        $scope.isClientDocuments = false;
        var operationsSinceRefresh = 0;

        var refresh = function() {
            $scope.$broadcast('dms-grid-refresh', $scope.container);
            operationsSinceRefresh = 0;
        };

        $scope.$on('dmsApprovalRequested', refresh);
        $scope.$on('dmsFolderAdded', refresh);
        $scope.$on('dmsDocumentAdded', refresh);
        $scope.$on('dmsItemShared', refresh);
        $scope.$on('dmsItemRenamed', refresh);

        function operationComplete() {
            operationsSinceRefresh++;
            if (operationsSinceRefresh >= 5) {
                refresh();
            }
        }

        $scope.$on('dms-file-added', operationComplete);

        $scope.$on('dms-operation-complete', function(event:any, operationModel:any) {
            var op = operationModel.type;
            if (op === 'move' || op === 'copy' || op === 'add' || op === 'delete' || op === 'moveToRecycle') {
                operationComplete();
            }
        });

        function batchComplete() {
            // Grid is being refreshed periodically as operations complete
            // Don't refresh if already refreshed due to previous operation completion
            if (operationsSinceRefresh > 0) {
                refresh();
            }
        }

        $scope.$on('dms-operation-batch-complete', batchComplete);
        $scope.$on('dms-upload-batch-complete', batchComplete);

        var unwrapData = function(result:any) {
            return result.data;
        };

        var getProject = function(projectId:any) {
            return dmsProjectUiService.getProject({
                scope: $scope,
                params: {
                    projectId: projectId
                }
            }).then(unwrapData);
        };

        var getFolder = function(folderId:any) {
            var cachedFolder = folderManager.getCachedFolderWithParentTree(folderId);
            if (cachedFolder) {
                return $q.when(cachedFolder);
            } else {
                return dmsFolderUiService.getFolder({
                    scope: $scope,
                    params: {
                        folderId: folderId
                    }
                }).then(unwrapData);
            }
        };

        $scope.clientSelected = function(item:any) {
            $state.go('clientStorageList', {
                clientId: item.id
            });
        };

        $scope.stateParams = $stateParams;

        var containerCache = dmsCacheFactory.getOrCreate('dms.folderMaster.container', 0, 100);

        if ($stateParams.folderId) {
            cacheThenRefresh(getFolder, $stateParams.folderId);
        } else {
            cacheThenRefresh(getProject, $stateParams.projectId || $stateParams.templateId);
        }

        function cacheThenRefresh(getContainer:any, containerId:any) {
            var cached = containerCache.get(containerId);
            if (cached) {
                updateContainer(cached);
            }

            getContainer(containerId).then(function(result:any) {
                containerCache.put(containerId, result);
                if (!cached || cached.modifiedDate !== result.modifiedDate) {
                    updateContainer(result);
                }
            });
        }

        function updateContainer(container:any) {
            $scope.container = container;
            var dragDropDisabled = container.lock && container.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') > -1;

            // Container may contain circular references, causing errors when interpolating.
            // This version is interpolation safe
            $scope.flatContainer = JSON.stringify({
                id: container.id,
                itemType: container.itemType,
                dragDropDisabled: dragDropDisabled
            });

            $timeout(function() {
                $scope.$broadcast('dms-grid-refresh', $scope.container);
            });

            if(container.rootType &&
                (container.rootType.toLowerCase() === 'firmtaxandaccountinglibrary' || container.rootType.toLowerCase() === 'mytaxandaccountinglibraries')) {
                $scope.container.rootType = container.rootType;

                $timeout(function() {
                    $scope.$emit('pageTitleUpdate', $scope.container);
                });
            } else if (container.containerType.toLowerCase() === 'projects' &&
                    container.primaryAssociationType &&
                    container.primaryAssociationType.toLowerCase() === 'client') {
                    $scope.container.primaryAssociationName = container.primaryAssociationName;
                $scope.isClientDocuments = true;
                $timeout(function() {
                    $scope.$emit('pageTitleUpdate', $scope.container);
                });
            } else if (container.parentId) {
                 dmsFolderService.getAncestors(container.id).then(function(ancestors:any) {
                    if(ancestors && ancestors.data) {
                        if(ancestors.data.rootType) {
                            if(ancestors.data.rootType.toLowerCase() === 'firmtaxandaccountinglibrary' ||
                                ancestors.data.rootType.toLowerCase() === 'mytaxandaccountinglibraries') {
                                $scope.container.rootType = ancestors.data.rootType;
                            } else if (ancestors.data.rootType.toLowerCase() === 'taxaccounting') {
                                var rootItem = ancestors.data;
                                do {
                                    rootItem = rootItem.parentItem;
                                } while (rootItem.parentItem);
                                $scope.container.primaryAssociationName = rootItem.primaryAssociationName ? rootItem.primaryAssociationName : '';
                                if (rootItem.primaryAssociationName && rootItem.primaryAssociationType.toLowerCase() === 'client') {
                                    $scope.isClientDocuments = true;
                                }
                            }
                        } else if (ancestors.data.containerType && ancestors.data.containerType.toLowerCase() === 'projects' && ancestors.data.primaryAssociationType.toLowerCase() === 'client') {
                            $scope.container.primaryAssociationName = ancestors.data.primaryAssociationName;
                            $scope.isClientDocuments = true;
                        }
                    }
                    $timeout(function() {
                        $scope.$emit('pageTitleUpdate', $scope.container);
                    });
                });
            }
            setColumnChooserGridId(container, $scope);
        }

        function setColumnChooserGridId(container:any, $scope:ng.IScope | any) {
            if (container.rootType) {
                if ($scope.isClientDocuments) {
                    _gridIdReady.resolve('client-documents');
                } else if (container.rootType.toLowerCase() === 'firmtaxandaccountinglibrary') {
                    _gridIdReady.resolve('firm-documents');
                } else if (container.rootType.toLowerCase() === 'mytaxandaccountinglibraries') {
                    _gridIdReady.resolve('my-documents');
                }
            } else if (container.containerType && container.containerType.toLowerCase() === 'projects') {
                _gridIdReady.resolve('folder-template-details');
            }
        }
    };

    controller.$inject = inject;

    angular.module('onvio.documents')
        .controller('folderMaster', controller);

})((window as any).angular);
